import classNames from 'classnames'
import * as React from 'react'

import {useIsAutodetectTimeZone} from '../../../hooks/useIsAutodetectTimeZone'
import {PlaceIdList} from '../../../plugins/plugins.types'
import {displayDate} from '../../../utils/dateTimeUtils'
import BuildAgentLink from '../AgentLink/BuildAgentLink.container'
import Plugin from '../Plugin/Plugin'

import type {Props} from './AgentInfo.types'
import AgentPoolLink from './AgentPoolLink/AgentPoolLink.container'

import styles from './AgentInfo.css'

function AgentInfo({
  className,
  buildId,
  withLabel,
  withAgent,
  withPool,
  detachedFromAgent,
  finishOnAgentDate,
  secondary,
  isQueued,
}: Props) {
  const isAutodetectTimeZone = useIsAutodetectTimeZone()

  if (!withAgent) {
    return null
  }

  const classes = classNames(className, styles.wrapper)

  const value = (
    <>
      <BuildAgentLink className={styles.agent} buildId={buildId} secondary={secondary} />
      {withPool && (
        <>
          {' — '}
          <AgentPoolLink className={styles.agentPool} buildId={buildId} secondary={secondary} />
        </>
      )}
      <Plugin inline placeId={PlaceIdList.SAKURA_AFTER_AGENT_INFO} />
    </>
  )

  return withLabel ? (
    <tr className={classes}>
      <th>
        {isQueued ? 'Planned agent' : detachedFromAgent ? 'Detached from\u00a0agent' : 'Agent'}
      </th>
      <td>
        {value}
        {detachedFromAgent && finishOnAgentDate != null
          ? ` on ${displayDate(finishOnAgentDate, isAutodetectTimeZone, true)}`
          : ''}
      </td>
    </tr>
  ) : (
    <div className={classes}>{value}</div>
  )
}

export default React.memo(AgentInfo)
